import styled from "styled-components";

import { Button, Message } from "@design-system-coopeuch/web";

export const StyledWrapperAccordion = styled.section`
  background: yellow;
  & .AccordionItem--header {
    padding: 20px 32px;
    & .AccordionItem--collapsed-indicator > img {
      width: 14px;
    }
  }
  & .AccordionItem--content {
    padding: 0;
  }
  & .AccordionItem--title {
    font-size: 18px;
    line-height: 24px;
  }
  & .AccordionItem--subtitle {
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
    margin-top: 8px;
  }
  & .AccordionItem--subtitle:empty {
    margin-top: 0px;
  }
`;

export const StyledWrapperCards = styled.div`
  /* TODO: Estilos que se repiten en otro wrapper, ver si se mueven a un style global */
  display: grid;
  grid-row-gap: 16px;
  @media screen and (min-width: 768px) {
    grid-row-gap: 32px;
  }

  && .CardBase--shaded {
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.14);
  }
  && .CardBase_content--no-padding > div {
    padding-right: 16px;
    padding-left: 16px;
    @media screen and (min-width: 768px) {
      padding-right: 32px;
      padding-left: 32px;
    }
  }
  & .CardBase > header {
    padding: 16px 16px;
    @media screen and (min-width: 768px) {
      padding: 20px 32px;
    }
  }
  & .CardBase--titles {
    row-gap: 4px;
  }
  & .CardBase--titles > h2 {
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
    @media screen and (min-width: 768px) {
      font-size: 24px;
      line-height: 30px;
    }
  }
  & .CardBase--titles > h4 {
    font-size: 14px;
    line-height: 20px;
  }
  & .CardBase p {
    font-size: 14px;
  }
  & .CardBase .title-content {
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
  }
  & .CardBase .subtitle-content {
    font-size: 14px;
    line-height: 20px;
  }
  & .CardBase .text-content {
    font-size: 14px;
    line-height: 22px;
  }
  /* TODO: Fin estilos repetidos */
`;

export const StyledButton = styled(Button)`
  justify-content: start;
  padding: 0px;

  & > span {
    font-size: 16px;
  }
`;

export const StyledMessage = styled(Message)`
  & > div:nth-child(1) > div {
    display: flex;
    flex-direction: column;
    @media screen and (min-width: 768px) {
      flex-direction: row;
      align-items: center;
      & > p {
        margin-left: 0.5rem;
      }
    }
    & > div {
      font-weight: bold;
    }
  }
`;

export const StyleGridVoucher = styled.div`
  .gray-section {
    background: #f6f6f6;

    p {
      font-weight: bold;
      span {
        font-weight: 400 !important;
        color: #383838;
      }
    }
  }

  .white-section {
    background: #ffffff;
    p {
      font-weight: bold;
      span {
        font-weight: 400 !important;
        color: #383838;
      }
    }
  }

  .span_1 {
    margin-left: 12rem;
  }
  .span_2 {
    margin-left: 14rem;
  }
  .span_3 {
    margin-left: 4rem;
  }
  .span_4 {
    margin-left: 5.5rem;
  }
  .span_5 {
    margin-left: 5rem;
  }
  .span_6 {
    margin-left: 6.6rem;
  }
  .span_6_1 {
    margin-left: 8.4rem;
  }
  .span_7 {
    margin-left: 8.8rem;
  }
  .span_7_1 {
    margin-left: 9.4rem;
  }
  .span_8 {
    margin-left: 11rem;
  }
  .span_9 {
    margin-left: 2rem;
  }
  .span_10 {
    margin-left: 7.9rem;
  }
  .span_11 {
    margin-left: 6.5rem;
  }
  .span_12 {
    margin-left: 4.9rem;
  }

  @media screen and (max-width: 768px) {
    .span_1,
    .span_2,
    .span_3,
    .span_4,
    .span_5,
    .span_6,
    .span_7,
    .span_8,
    .span_9,
    .span_10,
    .span_11 {
      margin-left: 2rem;
    }
  }
`;

export const StyledGridWrapper = styled.div`
  display: grid;
  grid-row-gap: 16px;
  & .CardBase header {
    padding: 16px 18px;
  }
  & .CardBase--titles span {
    font-size: 18px;
    font-weight: bold;
  }
`;

export const StyleTextPasswordDigital = styled.div`
  .title-habilitador {
    text-align: initial;
    padding-left: 15px;
    //padding-top: -19px;
    margin-top: -39px !important;
    margin-bottom: 11px !important;
  }
  .span-habilitador {
    text-align: initial;
    padding-left: 13px;
  }

  .text-btn {
    font-size: 20px !important;
    margin-top: -6rem !important;
    margin-left: 32rem !important;
    // display: inline;
  }

  .altura-grid {
    height: 210px;
  }

  @media screen and (max-width: 767px) {
    .altura-grid {
      height: 280px !important;
    }
    .img-responsive-icon {
      margin-left: -16rem !important;
      width: 60px;
      height: 60px;
    }
    .title-habilitador {
      text-align: justify;
      margin-bottom: 40px !important;
      margin-top: -55px;
      margin-left: 4.5rem;
      width: 150px;
    }
    .span-habilitador {
      text-align: justify;
      font-size: 14px !important;
      word-spacing: -1px !important;
    }
    .content-span {
      margin-bottom: 2rem;
    }
    .text-btn {
      /* font-size: 20px !important;
      display: inline;
      margin-top:0;
      margin-left: 0; */
      margin-left: auto !important;
      margin-top: auto !important;
    }
  }
`;

/* istanbul ignore next */
export const StyledWrapperProgressBarPassword = styled.article.attrs(() => ({
  className: "mt-1",
}))`
  display: flex;
  align-items: center;
  margin-left: 8px;
  flex: 1 0 auto;
  && > div > div {
    margin: 0px;
  }
  & > div > div:nth-child(2) {
    height: 5px;
    & > div {
      background-color: ${(props) =>
        props.progressColor ? `${props.progressColor}` : "#0e891a"} !important;
    }
  }
  & [data-progress="0"] {
    min-width: 0px !important;
  }
  & .text-name-step {
    color: #0e891a !important;
    font-size: 14px;
  }
`;
